import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllLevyAmountTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.LevyAmountTypeAPI}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getLevyAmountTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.LevyAmountTypeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertLevyAmountType = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.LevyAmountTypeAPI,
    input
  );
  return data;
};

const updateLevyAmountType = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.LevyAmountTypeAPI,
    input
  );
  return data;
};

const deleteLevyAmountType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.LevyAmountTypeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetLevyAmountTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.LevyAmountTypeAPI],
    queryFn: () => getAllLevyAmountTypes(input),
    // refetchOnWindowFocus: false,
  });
};

export const useGetLevyAmountTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.LevyAmountTypeAPI],
    queryFn: () => getLevyAmountTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertLevyAmountTypeMutation = () => {
  return useMutation({
    mutationFn: insertLevyAmountType,
  });
};

export const useUpdateLevyAmountTypeMutation = () => {
  return useMutation({
    mutationFn: updateLevyAmountType,
  });
};

export const useDeleteLevyAmountTypeMutation = () => {
  return useMutation({
    mutationFn: deleteLevyAmountType,
  });
};
